import * as React from 'react';
import { clampListIndex } from './clamp-list-index';
import { lightboxReducer } from './lightbox-reducer';
import { LightboxState, initialState } from './lightbox-reducer.state';
import { LightboxAction } from './lightbox-reducer.actions';

export function useLightboxReducer(
    providedInitialState?: Partial<LightboxState>,
): [LightboxState, React.Dispatch<LightboxAction>] {
    const elements = providedInitialState?.elements ?? initialState.elements;
    const index = clampListIndex(elements.length, providedInitialState?.index ?? initialState.index);
    const isLoopbackEnabled = providedInitialState?.isLoopbackEnabled ?? initialState.isLoopbackEnabled;
    return React.useReducer(lightboxReducer, {
        elements,
        index,
        isLoopbackEnabled,
    });
}
